import recaptcha from '@components/App/RecaptchaWidget/recaptcha'
import type { ExportDto } from '@octopus-do/octopus-api-client'
import axios from 'axios'

const pdfFileName = (url: string) => {
  try {
    return `${new URL(url).host.replace(/^www\./, '')}-sitemap-report.pdf`
  } catch {
    return 'Website-sitemap-report.pdf'
  }
}

export const downloadReportPdf = async (data: ExportDto): Promise<void> => {
  const exportUrl: string | undefined = import.meta.env.VITE_EXPORT_PDF_API_URL
  if (!exportUrl) {
    throw new Error('PDF export service is not configured')
  }
  const responseKey = await recaptcha.execute({ action: 'export_report_pdf' })
  if (!responseKey) {
    throw new Error('PDF export verification failed')
  }
  const response = await axios.post(
    `${exportUrl.replace(/\/$/, '')}/export-report`,
    { report: data },
    { params: { responseKey }, responseType: 'blob', timeout: 120_000 }
  )
  const downloadUrl = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  try {
    link.href = downloadUrl
    link.download = pdfFileName(data.site.url)
    link.click()
  } finally {
    URL.revokeObjectURL(downloadUrl)
  }
}
